module.exports = __webpack_public_path__ + "img/bg.d7c12963.png";